import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useApi from '../../hooks/useApi';
//
// Миникнопка для привязки/отвязки админа к мероприятию.
// Используется на странице мероприятия и администратора.
//
const EventToAdminBind = ({ event, admin, bind }) => {
	const { t } = useTranslation();
    const user = useSelector(state => state.auth.user);
    // eslint-disable-next-line
    const [ params, setParams ] = useState({ admin, event });
    const [ type, setType ] = useState('undefined');
	const [ data, error, isLoading ] = useApi({ type, method: '/a2e', params });

    const doBind = () => {
        // Изначально мы указали несуществующий тип запроса к АПИ.
        // После нажатия на компонент мы подставляем в тип нужный
        // вариант и вызываем тем самым повторный вызов АПИ.
        if(bind) {
            setType('post');
        } else {
            setType('delete');
        }
    };

	return (
    <React.Fragment>
        {user.role !== 'root' ? <React.Fragment/> :
        <React.Fragment>&nbsp;
            {isLoading ? <div className='InlineButtonBlank'>{t('common.loading')}</div> :
            <React.Fragment>
                {error ? <div className='InlineButtonBlank'>{t('common.error')}</div> :
                <React.Fragment>
                    {data ? <div className='InlineButtonBlank'>{t('common.noerror')}</div> :
                    <div className='InlineButtonSolid' onClick={doBind}>{bind ? t('common.bind') : t('common.unbind')}</div>}
                </React.Fragment>}
            </React.Fragment>}
        </React.Fragment>}
    </React.Fragment>);
};

EventToAdminBind.propTypes = {
    admin:  PropTypes.string.isRequired, // id администратора
    event:  PropTypes.string.isRequired, // id мероприятия
    bind:   PropTypes.bool.isRequired,   // true - нужна привязка, false - нужна отвязка
};

export default EventToAdminBind;
